import { useMemo } from 'react'
import { useLocation } from 'react-router'

export default function useLocationSearchParams() {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}
